import React from "react";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";
import { payProvider } from "../../variables/app";

function PayProviderFilter(props) {
  const { classes } = props;
  const payProviders = [
    {
      value: "0",
      label: "All Payment Providers",
    },
    ...payProvider,
    {
      value: "NULL",
      label: "No Payment Provider",
    },
  ];

  return (
    <Select
      MenuProps={{
        className: classes.selectMenu,
      }}
      classes={{
        select: classes.select,
      }}
      inputProps={{
        name: "simpleSelect",
        id: "simple-select",
        style: { paddingTop: "32px" },
      }}
      onChange={(e) => {
        let value = e.target.value;

        switch (value) {
          case "0":
            props.setFilter("payProvider", null);
            break;
          case "NULL":
            props.setFilter("payProvider", { field: "payProvider", operator: null, value: null });
            break;
          default:
            props.setFilter("payProvider", { field: "payProvider", operator: "=", value: value });
            break;
        }
      }}
      style={{ backgroundColor: props.payProvider === null ? null : "#ff9800" }}
      value={props.payProvider?.value ? props.payProvider.value : props.payProvider == null ? "0" : "NULL"}
    >
      {payProviders.map((item) => (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={item.value}
          value={item.value}
        >
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}

const mapStateToProps = (state) => ({
  ["payProvider"]: state.filtersV2["payProvider"],
  /*   ["vestiging_id"]: state.filtersV2["vestiging_id"], */
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(PayProviderFilter, productenStyle));
